import { render, staticRenderFns } from "./GifMessageElement.vue?vue&type=template&id=00fa6279&scoped=true&"
import script from "./GifMessageElement.vue?vue&type=script&lang=babel&"
export * from "./GifMessageElement.vue?vue&type=script&lang=babel&"
import style0 from "./GifMessageElement.vue?vue&type=style&index=0&id=00fa6279&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fa6279",
  null
  
)

export default component.exports